var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightInline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.855 7.839l4.714 4.166-4.714 4.167a.984.984 0 000 1.514c.474.419 1.24.419 1.713 0l5.577-4.929a.984.984 0 000-1.514l-5.577-4.929a1.325 1.325 0 00-1.713 0c-.461.419-.473 1.106 0 1.525z",
    fill: "currentColor"
  })));
}
export default SvgArrowRightInline;